export default __webpack_public_path__ + "static/media/pep_logo.b3714f66.svg";